module.exports = __webpack_public_path__ + "assets/images/Logo_trasp copia.png";